<template>
  <div class="carousel-container" ref="ccList">
    <div class="img-container" v-for="(img, key) in getAppDefinitions?.ads" :key="key" >
      <a :href="img.href" target="_blank"><img :src="img.image"></a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CarouselList',
  data () {
    return {
      interval: null,
      userScrolling: false,
      scrollTimeout: null
    }
  },
  computed: {
    ...mapGetters(['getAppDefinitions'])
  },
  methods: {
    onScroll: function () {
      const sf = this
      sf.userScrolling = true
      clearTimeout(sf.scrollTimeout)
      sf.scrollTimeout = setTimeout(() => {
        sf.userScrolling = false
      }, 5000)
    },
    startAutoScroll: function () {
      const sf = this
      sf.$refs.ccList.addEventListener('scroll', sf.onScroll)
      const nodeList = Array.from(sf.$refs.ccList.childNodes).filter(node => node.nodeType === 1)
      sf.interval = setInterval(() => {
        if (sf.userScrolling) {
          return
        }

        if (!nodeList?.length) {
          clearInterval(sf.interval)
          return
        }
        const activeElement = nodeList.find(i => i.classList.contains('active'))

        if (!activeElement) {
          nodeList[0].classList.add('active')
        } else {
          const curIndex = nodeList.indexOf(activeElement)
          const nextIndex = (curIndex + 1) % nodeList.length

          nodeList.forEach(i => i.classList.remove('active'))
          nodeList[nextIndex].classList.add('active')
        }

        nodeList.find(i => i.classList.contains('active')).scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }, 5000)
    }
  },
  mounted () {
    this.startAutoScroll()
  },
  updated () {
    this.startAutoScroll()
  },
  beforeUnmount () {
    this?.$refs?.ccList?.removeEventListener('scroll', this.onScroll)
    clearTimeout(this.scrollTimeout)
    clearInterval(this.interval)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.carousel-container {
  scroll-snap-type: x mandatory;
  flex-flow: row nowrap;
  overflow-y: hidden;
  max-height: 190px;
  padding: 0 20px 15px 20px;
  margin: 20px -20px;
  display: flex;

  .img-container {
    margin-right: 15px;
    scroll-snap-align: center;
    display: inline-block;
    flex: none;
    min-height: 190px;

    &:last-of-type {
      margin-right: 0;
    }

    img {
      object-fit: cover;
      max-height: 190px;
      max-width: 100%;
      width: 350px;
    }
  }
}
</style>
